'use client';

import { AlertDialog } from '@tuic/web-compositions/shared/AlertDialog';
import { ButtonGroup } from '@tuic/web-compositions/core/ButtonGroup';
import { TextButton } from '@tuic/web-compositions/core/TextButton';
import { FC, useState } from 'react';
import { useClientTranslation } from '@lib/i18n/client';
type Props = {
  getIframeUrl?: () => URL;
};
export const Mxp365DebugFooter: FC<Props> = ({
  getIframeUrl
}) => {
  const {
    t
  } = useClientTranslation();
  const [urlVisible, setUrlVisible] = useState(false);
  const handleClick = () => {
    setUrlVisible(true);
  };
  const handleClose = () => setUrlVisible(false);
  return <div className="px-4 flex items-center" data-sentry-component="Mxp365DebugFooter" data-sentry-source-file="Mxp365DebugFooter.tsx">
      <ButtonGroup data-sentry-element="ButtonGroup" data-sentry-source-file="Mxp365DebugFooter.tsx">
        <TextButton onClick={handleClick} data-sentry-element="TextButton" data-sentry-source-file="Mxp365DebugFooter.tsx">
          {t('Iframe-URL anzeigen')}
        </TextButton>
      </ButtonGroup>
      <AlertDialog open={urlVisible} onOpenChange={handleClose} title={t('Iframe-URL des MXP365-Dialogs')} actions={[{
      title: t('Schließen')
    }]} data-sentry-element="AlertDialog" data-sentry-source-file="Mxp365DebugFooter.tsx">
        <code className="break-words">
          {getIframeUrl?.().toString() ?? t('URL nicht verfügbar.')}
        </code>
      </AlertDialog>
    </div>;
};